import Vue from 'vue'

declare let YubinBango: any

type Data = {
  scriptEl?: HTMLScriptElement
}

type Methods = {
  loadScript: () => void
  unloadScript: () => void
  loadAddress: (zipcode: string) => Promise<AddressResponse | null>
}

type YubinBangoAddress = {
  region_id: number
  region: string
  locality: string
  street: string
  extended: string
}

export type AddressResponse = {
  prefId: number
  locality: string
  street: string
}

export default Vue.extend<Data, Methods, {}, {}>({
  data() {
    return { scriptEl: undefined }
  },
  mounted() {
    this.loadScript()
  },
  beforeDestroy() {
    this.unloadScript()
  },
  methods: {
    loadScript() {
      // YubinBango module が export されていない #4
      // https://github.com/yubinbango/yubinbango-core/issues/4
      const script = document.createElement('script')
      script.setAttribute(
        'src',
        'https://yubinbango.github.io/yubinbango-core/yubinbango-core.js'
      )
      this.$data.scriptEl = script
      this.$el.appendChild(this.$data.scriptEl)
    },
    unloadScript() {
      this.$el.removeChild(this.$data.scriptEl)
    },
    loadAddress(zipcode) {
      return new Promise((resolve, reject) => {
        if (!zipcode || !zipcode.match(/^\d\d\d-\d\d\d\d$/)) {
          resolve(null)
        }
        return new YubinBango.Core(zipcode, (address: YubinBangoAddress) => {
          if (!address.region_id) {
            reject(new Error(this.$tc('validations.zipNotFound')))
          }

          resolve({
            prefId: address.region_id,
            locality: address.locality,
            street: address.street,
          })
        })
      })
    },
  },
})
